import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Checkbox } from 'antd';
import { parseStringOr, parseBoolOr } from '../../App/AppxUtils';


function InputCheckbox(props) {
    const { t } = useTranslation('appxweb');
    const name = parseStringOr(props.name, "");
    const required = parseBoolOr(props.required, false);
    const label = parseStringOr(props.label, null);
    let rules = [];

    if (required) {
        let rule = {
            required: true,
        }

        if (label != null) {
            rule.message = t('AppxForm.input_required', {field: label});
        }

        rules.push(rule);
    }

    if (Array.isArray(props.rules) && props.rules.length > 0) {
        rules = [...rules, ...props.rules];
    }

    return (
        <Form.Item
            className={props.className}
            name={name}
            label={label}
            valuePropName={props.valuePropName||'checked'}
            rules={rules}
            help={props.help}
            style={props.style}
        >
            <Checkbox
                autoFocus={props.autoFocus}
                disabled={props.disabled}
                defaultChecked={props.defaultChecked}
                onChange={props.onChange}
                checked={props.checked}
                style={props.checkboxStyle}
            >
                {props.children}
            </Checkbox>
        </Form.Item>
    );
}

export default InputCheckbox;
